import React from 'react';
import { Image } from 'react-bootstrap';
import './FramedImage.css';

function FramedImage({ src, alt, imageClassName = '' }) {
    return (
        <div className='framedImageWrap'>
            <div className='cornerAccent cornerAccent--top'></div>
            <Image src={src} alt={alt} className={`framedImage ${imageClassName}`.trim()} />
            <div className='cornerAccent cornerAccent--bottom'></div>
        </div>
    );
}

export default FramedImage;
